import { render, staticRenderFns } from "./CampaignDetailsCard.vue?vue&type=template&id=08ff8bb2&scoped=true"
import script from "./CampaignDetailsCard.vue?vue&type=script&lang=js"
export * from "./CampaignDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./CampaignDetailsCard.vue?vue&type=style&index=0&id=08ff8bb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ff8bb2",
  null
  
)

export default component.exports